"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commandMapping = void 0;
exports.commandMapping = new Map([
    ['placeOrder', 'sibcAjaxDefault'],
    ['applyCouponToExistingOrder', 'applyOrderDiscount'],
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/checkoutAPI/config.js
// module id = 3382
// module chunks = 11